import type { RelationOutputForSeller } from "@/api/custom_types";
import { useTranslation } from "@/hooks/useTranslation";
import { formatNumber } from "@/utils/tools";
import {
	Chip,
	Icon,
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from "@st-marketplace/ui";

interface RelationPriceCellProps {
	price: RelationOutputForSeller["final_price"];
}

const RelationPriceCell: React.FC<RelationPriceCellProps> = ({ price }) => {
	const { t } = useTranslation();
	const isLocal = price.type === "local";

	return (
		<span className="inline-flex items-center gap-1">
			<span className="tabular-nums">{formatNumber(price.value, "price")}</span>
			<Tooltip>
				<TooltipTrigger asChild>
					<span className="inline-flex cursor-help">
						<Chip variant={isLocal ? "info" : "muted"} size="sm">
							<span className="inline-flex items-center gap-0.5">
								{t(
									isLocal
										? "relation.priceSourceLabelLocal"
										: "relation.priceSourceLabelGlobal",
								)}
								<Icon
									name="information-line"
									size="xs"
									className="opacity-70"
								/>
							</span>
						</Chip>
					</span>
				</TooltipTrigger>
				<TooltipContent>
					<p>
						{t(
							isLocal
								? "relation.priceSourceTooltipLocal"
								: "relation.priceSourceTooltipGlobal",
						)}
					</p>
					<p>{t("relation.priceSourceTooltipHint")}</p>
				</TooltipContent>
			</Tooltip>
		</span>
	);
};

export default RelationPriceCell;
